import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Typography, CircularProgress, IconButton } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useTranslation } from "react-i18next";
import { getProjectById } from "../services/projectService";
import { Project } from "../types";
import ProjectTasksList from "../components/ProjectTasksList";

const ProjectTasksPage: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [project, setProject] = useState<Project | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (projectId) {
      loadProject();
    }
  }, [projectId]);

  const loadProject = async () => {
    if (!projectId) return;
    setLoading(true);
    try {
      const projectData = await getProjectById(projectId);
      setProject(projectData);
    } catch (err: any) {
      console.error("Failed to load project:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading && !project) {
    return (
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          zIndex: 9999,
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  return (
    <Box sx={{ pb: { xs: 0, md: 2 }, position: "relative" }}>
      <Box
        sx={{
          display: { xs: "flex", sm: "none" },
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          bgcolor: "background.paper",
        }}
      >
        <IconButton
          onClick={() => navigate(`/project/${projectId}`)}
          sx={{
            color: "#757575",
            p: 1,
          }}
        >
          <ArrowBackIosNewIcon />
        </IconButton>
        <Typography
          variant="h5"
          sx={{ fontSize: { xs: "1.5rem", sm: "2rem" } }}
        >
          {project?.name || t("projects.detail.tasksTitle") || "Задачи"}
        </Typography>
        <Box sx={{ width: 100 }} />
      </Box>

      <Box sx={{ display: { xs: "none", sm: "block" }, mb: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <IconButton
            onClick={() => navigate(`/project/${projectId}`)}
            sx={{
              color: "#757575",
              p: 1,
              mr: 2,
            }}
          >
            <ArrowBackIosNewIcon />
          </IconButton>
          <Typography variant="h5" gutterBottom sx={{ fontSize: "2rem" }}>
            {project?.name || t("projects.detail.tasksTitle") || "Задачи"}
          </Typography>
        </Box>
      </Box>

      {projectId && <ProjectTasksList projectId={projectId} />}
    </Box>
  );
};

export default ProjectTasksPage;
